const BaseValidator = require('./BaseValidator')
const { ValidationError } = require('@plastiq/external-api-errors')

class NumberValidator {
  /**
   *
   * @param {*} argument - argument that is being validated
   * @param {string} argumentName - name of the argument to be shown in validation error
   * @param {object} options - options to validate specific attributes about number e.g. options.minNumber & options.maxNumber
   */
  static validate(argument, argumentName, options = {}) {
    const { minNumber, maxNumber } = options

    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    BaseValidator.guardAgainstIncorrectTypes(argument, argumentName, 'number')
    validateSize(argument, argumentName, minNumber, maxNumber)
  }
}

function validateSize(argument, argumentName, minNumber, maxNumber) {
  const hasMin = minNumber !== undefined
  const hasMax = maxNumber !== undefined

  if (hasMin && typeof minNumber !== 'number') {
    throw new Error(`minNumber is not a number: ${minNumber}`)
  }

  if (hasMax && typeof maxNumber !== 'number') {
    throw new Error(`maxNumber is not a number: ${maxNumber}`)
  }

  if (Number.isInteger(argument) && !Number.isSafeInteger(argument)) {
    throw new ValidationError(
      `Number: ${argumentName} ${argument} outside of safe integer range`,
    )
  }

  if (hasMin && hasMax) {
    if (argument < minNumber || argument > maxNumber) {
      throw new ValidationError(
        `Number: ${argumentName} ${argument} outside of valid range ${minNumber} to ${maxNumber}`,
      )
    }
  } else if (hasMin) {
    if (argument < minNumber) {
      throw new ValidationError(
        `Number: ${argumentName} ${argument} less than valid minimum ${minNumber}`,
      )
    }
  } else if (hasMax) {
    if (argument > maxNumber) {
      throw new ValidationError(
        `Number: ${argumentName} ${argument} greater than valid maximum ${maxNumber}`,
      )
    }
  }
}

module.exports = NumberValidator
